/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/**
 * Returns url formatted as a lowercase String
 * @param {String} text Input text
 * @return {String} newText URL String constructed from input text
 */
export default function normalizeFriendlyURL(text) {
	if (typeof text !== 'string') {
		throw new TypeError('parameter text must be a string');
	}

	return text
		.replace(/[^a-z0-9_-]/gi, '-')
		.replace(/^-+/, '')
		.replace(/--+/, '-')
		.toLowerCase();
}
